export default ({color, size}) =>
  <svg t="1753429173369" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
       p-id="9866" width={size} height={size}>
    <path
      d="M0 877.714286h1024v146.285714H0zM438.857143 0h146.285714v438.857143h292.571429l-365.714286 365.714286-365.714286-365.714286h292.571429z"
      p-id="9867" fill={color}></path>
  </svg>
;
